import React from 'react';
import { func, string } from 'prop-types';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';

import { Form, NamedLink, PrimaryButton } from '../..';

import css from './InquiryWithoutPaymentForm.module.css';
import { getAccountTypeForMembershipLink, userTypes } from '../../../util/userTypes';

const renderForm = formRenderProps => {
  // FormRenderProps from final-form
  const {
    formId,
    className,
    rootClassName,
    handleSubmit,
    currentUserHasSubscription,
    isOwnListing,
    currentUser
  } = formRenderProps;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <Form id={formId} onSubmit={handleSubmit} className={classes}>
      <div className={css.submitButton}>
        {currentUserHasSubscription ?
          isOwnListing ?
            <NamedLink name="SearchHouseSitPage" style={{ textDecoration: "none" }}>
              <PrimaryButton type="button">
                <FormattedMessage id="TopbarDesktop.houseSitLink" />
              </PrimaryButton>
            </NamedLink>
            :
            <PrimaryButton type="submit">
              <FormattedMessage id="InquiryWithoutPaymentForm.ctaButton" />
            </PrimaryButton>
          :
          <NamedLink
            name="MembershipPlansPage"
            style={{ textDecoration: "none", width: "100%" }}
            params={{ accountType: userTypes.homeowner }}
          >
            <PrimaryButton type="button">
              <FormattedMessage id="TopbarDesktop.memberBenefitsLink" />
            </PrimaryButton>
          </NamedLink>
        }
      </div>
      <p className={css.finePrint}>
        {isOwnListing &&
          <FormattedMessage id="ProductOrderForm.ownListing" />
        }
      </p>
    </Form>
  );
};

const InquiryWithoutPaymentForm = props => {
  const intl = useIntl();
  const initialValues = {};

  return <FinalForm initialValues={initialValues} {...props} intl={intl} render={renderForm} />;
};

InquiryWithoutPaymentForm.defaultProps = {
  rootClassName: null,
  className: null,
};

InquiryWithoutPaymentForm.propTypes = {
  rootClassName: string,
  className: string,

  // form
  formId: string.isRequired,
  onSubmit: func.isRequired,
};

export default InquiryWithoutPaymentForm;
